/**
 * Some API functions from @sgdocs/client do not throw when the response is 401. In widgets we often want them to do so.
 */
export async function throwOnUnauthorized<T>(response: Promise<T>, message: string): Promise<T> {
  let dataAsAny: any;
  try {
    const data = await response;
    dataAsAny = data;
  } catch (error) {
    throw new Error(`Error while calling API: ${message}`);
  }
  if (dataAsAny.status && dataAsAny.status === 401) {
    throw new Error(`Unauthorized to call API: ${message}`);
  }
  return dataAsAny;
}
